module.exports = __webpack_public_path__ + "img/google06.b653b360.jpg";